import React, { FC } from 'react';
import { IonTabButton } from '@ionic/react';

export interface AllieTabButtonProps {
  tab: string;
  href?: string;
  onClick?: () => void;
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  layout?: 'icon-top' | 'icon-start' | 'icon-end' | 'icon-bottom' | 'icon-hide' | 'label-hide';
  selected?: boolean;
  download?: string;
  rel?: string;
  target?: string;
}

/**
 * AllieTabButton - Wrapper around IonTabButton
 * Provides consistent tab button styling and behavior
 */
export const AllieTabButton: FC<AllieTabButtonProps> = ({
  tab,
  href,
  onClick,
  children,
  className,
  disabled = false,
  layout = 'icon-top',
  selected = false,
  download,
  rel,
  target,
}) => {
  return (
    <IonTabButton
      tab={tab}
      href={href}
      onClick={onClick}
      className={className}
      disabled={disabled}
      layout={layout}
      selected={selected}
      download={download}
      rel={rel}
      target={target}
    >
      {children}
    </IonTabButton>
  );
};

AllieTabButton.displayName = 'AllieTabButton';
